import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'

import { resetAllModifiedDataByKey } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import { QBRSectionAvailableWhenFinalized } from '../qbrSectionThatCanBeDisabled/QBRSectionAvailableWhenFinalized'

import { QBR_REPORT_FORM_KEY } from './components/reportModal/configs'
import { QBRReportModal } from './components/reportModal/QBRReportModal'

export const ReportIssue = () => {
  const [showModal, setShowModal] = useState(false)

  const dispatch = useAppDispatch()
  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const closeModal = useCallback(() => {
    setShowModal(false)
    dispatch(resetAllModifiedDataByKey(QBR_REPORT_FORM_KEY))
  }, [dispatch])

  return (
    <QBRSectionAvailableWhenFinalized>
      <Button color={'danger'} onClick={openModal}>
        <Translation text={TRANSLATION_KEYS.reportIssue} />
      </Button>

      <QBRReportModal show={showModal} onClose={closeModal} />
    </QBRSectionAvailableWhenFinalized>
  )
}
